<template>
  <pt-banner-manage class="pt-banner-manage__withData"></pt-banner-manage>
</template>

<script>
import PtBannerManage from './index'
export default {
  name: 'pt-banner-manage__withData',
  components: {
    'pt-banner-manage': PtBannerManage
  }
}
</script>
